<template>
  <transition name='fade'>
    <div class="modal code_box"
         v-if='visible'>
      <div class="code_type">
        <div class="code_type_title">
          <span>【耕云科技】</span>
          <span>韩飞，</span>
          <span>分享了一篇加密稿件</span>
        </div>
        <div class="code_type_title code_type_descrip"
             style="margin-top:30px;">
          <span>— 请输入提取码访问稿件—</span>
        </div>
        <div class="code_type_title"
             style="margin-bottom:6px;">
          <el-input v-model="codeInput"
                    placeholder="请输入提取码"></el-input>
        </div>
        <div class="code_type_title input_error">
          <span>提取码错误，请重新输入</span>
        </div>
        <div class="code_type_button">
          <el-button type="primary">确定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'extractcode',
  data() {
    return {
      visible: false,
      codeInput: ''
    }
  },
  mounted() {
    this.$root.eventHub.$on('extractCodeModel', (type, data) => {
      this.visible = true

    })


  },
  destroyed() {
    this.$root.eventHub.$off('extractCodeModel')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    },


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.code_box
  .code_type
    position relative
    padding-top 20px
    width 500px
    height 256px
    border-radius 6px
    background #fff

    .code_type_title
      margin-bottom 20px
      width 100%
      center()

      span
        time-title()

    .code_type_descrip
      span
        color #303133
        font-size 18px

    .input_error
      span
        color #F56969
        font-size 12px

    .code_type_button
      position absolute
      bottom 20px
      left 0
      width 100%
      center()

      button
        width 128px
        height 36px
        line-height 0
</style>
